export default __webpack_public_path__ + "f9bf90a975dbc9258fd6d17d403fafcc.svg";